import { render, staticRenderFns } from "./BestSellingCategories.vue?vue&type=template&id=f559c5d4"
import script from "./BestSellingCategories.vue?vue&type=script&lang=js"
export * from "./BestSellingCategories.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports